module.exports = __webpack_public_path__ + "img/Biker.4e1628b4.svg";